<style>
/* #export {
  padding-left:30px;
} */
.custom {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin-top: 30px;
}

.custom td,
.custom th {
  border: 1px solid #ddd;
  padding: 8px;
}

.custom th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
</style>
<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานจำนวนรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ ของแต่ละผู้ให้บริการ
        <small></small>
      </h1>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทรายงาน" required>
                            <el-select
                              ref="type_report"
                              v-model="form.type_report"
                              @change="clear_data"
                            >
                              <el-option label="รายเดือน" value="month"></el-option>
                              <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                              <el-option label="รายปี" value="year"></el-option>
                              <el-option label="ระหว่างปี" value="between_year"></el-option>
                              <el-option label="ไตรมาส" value="quarter"></el-option>
                              <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="รายชื่อผู้ให้บริการ" required>
                            <el-checkbox-group v-model="form.service_providers_sub">
                              <el-checkbox
                                 ref="provider_list"
                                    v-for="provider in this.store_providers" 
                                    :key="provider.id" 
                                    :label="provider.id">{{provider.brand_name}}
                              </el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.type_report === ''"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            default-value="2556"
                            v-bind:class="[form.type_report === 'month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              :default-value="defaultDate"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="monthfrom"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              :default-value="defaultDate"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              :default-value="defaultDate"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']"
                            required
                          >
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              :default-value="defaultDate"
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:50%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              :default-value="defaultDate"
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.type_report === 'between_quarter'"
                            v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']"
                            required
                          >
                            <el-select
                              style="width:20%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year_from"
                              :default-value="defaultDate"
                              ref="quarter_year_from"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:20%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              style="width:25%;"
                              v-model="form.type_data.quarter_year"
                              :default-value="defaultDate"
                              ref="quarter_year2"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item label="ประเภทเทคโนโลยี" required>
                            <el-select v-model="form.type_search" ref="type_search">
                              <el-option label="กรุณาเลือกประเภทเทคโนโลยี" value></el-option>
                              <el-option label="ADSL" value="ADSL"></el-option>
                              <el-option label="VDSL" value="VDSL"></el-option>
                              <el-option label="FTTx" value="FTTx"></el-option>
                              <el-option label="WIFI" value="WiFi"></el-option>
                              <el-option label="VAS" value="VAS"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                              <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                              <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                    </div>
                  </div>
                  <div v-if="displayChart&&showChart">
                    <div class="col-sm-12" style="text-align:right;">
                      <el-dropdown @command="exportFile" v-loading="pending">
                        <span class="btn btn-primary" >Export<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item icon="el-icon-download" command="pdf">Export PDF</el-dropdown-item>
                          <el-dropdown-item icon="el-icon-download" command="doc">Export DOC</el-dropdown-item>
                          <el-dropdown-item icon="el-icon-download" command="image">Export Image</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div id="chart" class="box-body" v-if="displayChart&&showChart">
                    <!-- <div id="test" class="col-sm-12" style="padding-top: 50px;" v-for="chart in this.store_charts" :key="chart.id">
                      <highcharts class="chart" style="max-height: 400px;" :options="chart"></highcharts><br><br>
                    </div> -->
                    <!-- <div id="container"></div> -->
                  </div>
                  <div class="box-body" v-if="showDataNotFound">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                 </div>
                 <div class="export" ref="chart" id="export" style="min-width: 400px; min-height: 400px; margin: 0 auto; overflow: auto">
                    <div id="container" style="max-height: 500px; align: center;"></div>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style>
th.text.highcharts-table-topheading {
  vertical-align: middle
}
.highcharts-data-table tr,
.highcharts-data-table th,
.highcharts-data-table td {
  border: 1px solid silver;
  height: 20px!important;
  min-width: 100px;
  max-width: 300px!important;
}
.highcharts-table-caption {
  display: none;
}
.highcharts-data-table table{
  width: auto;
  margin-left: auto;
  margin-right: auto;
}
</style>
<script>
import {Chart} from "highcharts-vue";
import Highcharts from "highcharts";
import moment from "moment";
import utility from "../../lib/utility";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom, Table, TableCell, TableRow, RelativeHorizontalPosition, WidthType, VerticalAlign, TextRun, BorderStyle } from "docx";
import { saveAs } from "file-saver";
export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      test_options: null,
      original_oprions: null,
      displayChart: false,
      showReport: null,
      dynamicDiv: [],
      mixedChart: null,
      displayText: "",
      label_position: "top",
      cType : false,
      form: {
        weighting: 1,
        type_search: "",
        frequency: ["900 MHz", "1800 MHz", "2100 MHz"],
        type_data: {
          quarterfrom: null,
          quarterto: null,
          yearfrom: null,
          yearto: null,
          monthto: null,
          monthfrom: null,
          monthOfyear: null,
          month: null,
          year: null,
          quarter: null,
          quarter_year_from: null,
          quarter_year: null
        },
        service_status: ['S','U','CS','CU'],
        graphAvg: 2,
        service_providers_sub: [],
        group: [],
        type_sele: "",
        type_report: "",
        year: "",
        quarter: "",
        compare_type: "provider"
      },
      options: {
        pieceLabel: {
          render: function(args) {
            return args.label + " " + args.value + "%";
          },
          overlap: true,
          fontSize: 14,
          fontStyle: "bold",
          fontColor: "#FFF"
        }
      },
      data: {},
      pending: false
    };
  },
  created() {
    var yyy = moment(new Date()).add(0, "y");
    this.defaultDate = yyy;
    this.$store.dispatch('Report_pmt/getGroupCompany','broadband')
    this.$store.dispatch('Report_pmt/getProviderByType','broadband')
  },
  computed: {
    ...mapState({
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      store_charts : store => store.Report_SI.charts,
      showChart : store => store.Report_SI.showChart,
      showDataNotFound: store => store.Report_SI.showDataNotFound
    })
  },
  mounted() {},
  watch : {
    store_providers : {
      handler : function(reload, empty) {
        this.form.service_providers_sub = reload.map(provider => provider.id)
      }
    },
    store_charts : {
      handler : function(reload, empty){
        if (reload.length > 0) {
          document.getElementById('container').style.display = "block";
          this.displayChart = true
          let options = reload[0]
          options.chart.renderTo = 'container'
          var chart1 = new Highcharts.Chart(options);
        } else {
          this.displayChart = false
          document.getElementById('container').style.display = "none";
        }
      }
    }
  },
  methods: {
    ...mapActions({
      searching: 'Report_SI/setChartData',
    }),
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.service_providers_sub = []
      }else{
        this.form.group = []
      }
    },
    checkProviders(type) {
      if (this.form.group != "" && type == 2) {
        this.form.retail_service_provider = "";
      } else if (this.form.retail_service_provider != "" && type != 2) {
        this.form.group = "";
      }
    },
    clear_data() {
      this.form.type_data = {
        quarterfrom: null,
        quarterto: null,
        yearfrom: null,
        yearto: null,
        monthfrom: null,
        monthto: null,
        month: null,
        monthOfyear: null,
        year: null,
        quarter: null,
        quarter_year_from: null,
        quarter_year: null
      };
    },
    find_chart() {
      // เช็คการเลือกประเภทรายงาน
      if (this.form.type_report == "") {
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานรายเดือน month
      if (
        this.form.type_report == "month" &&
        this.form.type_data.month == null
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานระหว่างเดือน
      if (
        (this.form.type_report == "between_month" &&
          this.form.type_data.monthfrom == null) ||
        (this.form.type_report == "between_month" &&
          this.form.type_data.monthto == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom == null) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงเวลา year
      if (this.form.type_report == "year" && this.form.type_data.year == null) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงเวลา between year
      if (
        (this.form.type_report == "between_year" &&
          this.form.type_data.yearfrom == null) ||
        (this.form.type_report == "between_year" &&
          this.form.type_data.yearto == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom == null) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      // เช็คการเลือกประเภทรายงานและช่วงไตรมาส
      if (
        this.form.type_report == "quarter" &&
        this.form.type_data.quarter == null
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      //  ช็คการเลือกประเภทรายงานและช่วง quarterss
      if (
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarterfrom == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarterto == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarter_year_from == null) ||
        (this.form.type_report == "between_quarter" &&
          this.form.type_data.quarter_year == null)
      ) {
        this.$alert("กรุณาเลือกช่วงเวลา", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom == null) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto == null) {
              this.$refs.quarterto.focus();
            } else if (this.form.type_data.quarter_year == null) {
              this.$refs.quarter_year2.focus();
            } else {
              this.$refs.quarter_year_from.focus();
            }
          }
        });
        this.displayText = "";
        return false;
      }
      if (this.form.compare_type=="group" && this.form.group.length == 0 ) {
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.group.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      else if(this.form.compare_type=="provider" && this.form.service_providers_sub.length == 0){
        this.$alert("กรุณาเลือกรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.group.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      if (this.form.type_search == "") {
        this.$alert("กรุณาเลือกประเภทเทคโนโลยี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            // this.$refs.type_search.focus();
          }
        });
        this.displayText = "";
        return false;
      }
      let tableDiv = document.querySelectorAll('.highcharts-data-table');
          if (tableDiv.length > 0) {
            for(let i = 0; i < tableDiv.length; i++) {
              tableDiv[i].innerHTML = ''
            }
            
          }
      let formdata = this.form
      formdata.list = this.form.compare_type == "group" ? this.store_groups.filter(item => this.form.group.includes(item.id)) : this.store_providers.filter(item => this.form.service_providers_sub.includes(item.id))
      this.searching(formdata)
    },
    dashedBorder(myChart) {
      Chart.helpers.each(
        myChart.getDatasetMeta(0).data,
        function(rectangle, index) {
          rectangle.draw = function() {
            myChart.chart.ctx.setLineDash([0, 40]);
            Chart.elements.Rectangle.prototype.draw.apply(this, arguments);
          };
        },
        null
      );
    },
    async generatePDF() {
      var table = document.querySelector('.highcharts-data-table');
      var chart_height = 0
      var ratio = 0
      await this.$html2canvas(document.querySelector('.highcharts-container'), {
        canvas: null,
        onclone: function(clone) {
          clone.querySelector('.highcharts-root').style.width = '100%';
          clone.querySelector('.highcharts-root').style.height = 'auto';
          clone.querySelector('.highcharts-root').style.objectFit = 'cover';
        }
      }).then(function(cv) {
        console.log(cv)
        ratio = cv.height/cv.width
      });
      if (table != null && table.children.length > 0) {
          var width = 794;
          var height = 1123;
          var doc = new jsPDF("p","pt", [width, height]);
      } else {
          var width = 1123;
          var height = 794;
          // var height = width*ratio;
          var doc = new jsPDF("l","pt", [width ,height]);
      }
      await this.$html2canvas(document.querySelector('.highcharts-container'), {
        canvas: null,
        onclone: function(clone) {
          clone.querySelector('.highcharts-root').style.width = '100%';
          clone.querySelector('.highcharts-root').style.height = 'auto';
          clone.querySelector('.highcharts-root').style.objectFit = 'cover';
        }
      }).then(function(canvas) {
        const img = canvas.toDataURL("image/png", 1.0);
        chart_height = width*(canvas.height/canvas.width)
        doc.addImage(img, "JPEG", 0, 0, width, chart_height);
      });
      if (table != null && table.children.length > 0) {
        await this.$html2canvas(table, {
          canvas: null
        }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          var table_left = width*(canvas.height/canvas.width)
          doc.addImage(img, "JPEG", 0, chart_height, width, width*(canvas.height/canvas.width));
          table_left -= (table_left - chart_height)
          while(table_left >= 0) {
            let position = table_left - height
            doc.addPage();
            doc.addImage(img, "JPEG", 0, position, width, width*(canvas.height/canvas.width));
            table_left -= height
          }
        });
      }
      doc.save("services_internet_report.pdf");
    },
    exportDoc(){
      this.pending = true
      setTimeout(()=>{
        this.pending = false
        this.$html2canvas(document.querySelector('.highcharts-container')).then(function (cv) {
          console.log(cv)
        })
        this.$html2canvas(document.querySelector('.highcharts-container')).then(function(canvas) {
          var img = canvas.toDataURL("image/png", 4.0);
          let img_prop = canvas.width/canvas.height;
          var table = document.querySelector('.highcharts-data-table');
          const doc = new Document();
          let size = (table != null && table.children.length > 0) ? 560 : 920
          const image = Media.addImage(doc, img, size, size/img_prop)
          if (table != null && table.children.length > 0) {
            var temp_table = table.children[0]
            var header = temp_table.children[1]
            header = header.children[0]
            var body = temp_table.children[2]
            let cell = []
            var temp_row = []
            for(let i = 0; i < header.children.length; i++) {
              cell.push(
                new TableCell({
                  width: {size: 100/header.children.length, type: WidthType.PERCENTAGE},
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: header.children[i].textContent,
                          size: 14
                        })
                      ],
                      alignment: AlignmentType.CENTER
                    })
                  ] 
                })
              )
            }
            temp_row.push(new TableRow({
              children: cell
            }))
            cell = []
            for(let i = 0; i < body.children.length; i++) {
              let row = body.children[i]
              for(let j = 0; j < row.children.length; j++) {
                cell.push(
                  new TableCell({
                    width: {size: 100/header.children.length, type: WidthType.PERCENTAGE},
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: row.children[j].textContent,
                            size: 14
                          })
                        ],
                        alignment: AlignmentType.CENTER
                      })
                    ] 
                  })
                )
              }
              temp_row.push(new TableRow({
                children: cell
              }))
              cell = []
            }
            var data_table = new Table({alignment: AlignmentType.CENTER, rows: temp_row})
          }
          let export_data = (table != null && table.children.length > 0) ? [new Paragraph({children: [image], alignment: AlignmentType.CENTER}),  data_table] : [new Paragraph({children: [image], alignment: AlignmentType.CENTER})];
          doc.addSection({
            size: {
              orientation: (table != null && table.children.length > 0) ? PageOrientation.PORTRAIT : PageOrientation.LANDSCAPE,
            },
            children: export_data,
          });
          Packer.toBlob(doc).then(blob => {
            saveAs(blob, "services_inernet_report.doc");
          });
        });
      },2000)
    },
    async exportImage() {
      var table = document.querySelector('.highcharts-data-table');
      let test = document.querySelector('.export')
      await this.$html2canvas(test, {
        canvas: null,
        onclone: function(clone) {
          clone.querySelector('.highcharts-root').style.width = '100%';
          clone.querySelector('.highcharts-root').style.height = 'auto';
          clone.querySelector('.highcharts-root').style.objectFit = 'cover';
        }
      }).then(function (cv) {
        console.log(cv)
      })
      await this.$html2canvas(test, {
        canvas: null,
        onclone: function(clone) {
          clone.querySelector('.highcharts-root').style.width = '100%';
          clone.querySelector('.highcharts-root').style.height = 'auto';
          clone.querySelector('.highcharts-root').style.objectFit = 'cover';
        }
      }).then(function (canvas) {
        const canvas_image = canvas.toDataURL("image/png", 4.0);
        let img = new Image(); // create a new blank image
        img.src = canvas_image;
        img.onload = function (data) {
          saveAs(data.path[0].src, "services_internet_report.png");
        }
      }).then(()=>{
        setTimeout(() => {
          this.pending = false
        }, 500);
      })
    },
    exportFile(com) {
      if(com == 'doc') {
        this.exportDoc()
      } else if (com == 'pdf') {
        this.generatePDF()
      } else if (com == 'image') {
        this.exportImage()
      }
    },
  }
};
</script>
